var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step-content" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "step-inner-content" },
      [
        _c("ToggleWrapper", {
          attrs: {
            caption: "Presets",
            items: ["Custom", "Sport", "Entertainment", "Lifestyle"],
            noshrink: "",
          },
          on: { input: _vm.onPresetChange },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "split-content" },
          [
            _c("Uploader", {
              ref: "uploader-logo",
              staticClass: "logo",
              attrs: { caption: "Logo" },
              on: { "preview-change": _vm.onLogoPreviewChange },
            }),
            _vm._v(" "),
            _c("Uploader", {
              ref: "uploader-background",
              staticClass: "bg",
              attrs: { caption: "Background" },
              on: { "preview-change": _vm.onBackgroundPreviewChange },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("PickerWrapper", {
          ref: "picker-accent",
          attrs: { uniqueClass: "a", caption: "Accent color" },
          model: {
            value: _vm.Global.mockupConfig.colors.icons,
            callback: function ($$v) {
              _vm.$set(_vm.Global.mockupConfig.colors, "icons", $$v)
            },
            expression: "Global.mockupConfig.colors.icons",
          },
        }),
        _vm._v(" "),
        _c("FontsWrapper", {
          attrs: { caption: "Typography", fonts: _vm.selectedFonts },
        }),
        _vm._v(" "),
        _c("ToggleWrapper", {
          attrs: {
            tempDelay: "",
            caption: "Menu location",
            items: ["Left", "Top"],
          },
          on: { tempDisable: _vm.noTrans },
          model: {
            value: _vm.Global.mockupConfig.topNav,
            callback: function ($$v) {
              _vm.$set(_vm.Global.mockupConfig, "topNav", $$v)
            },
            expression: "Global.mockupConfig.topNav",
          },
        }),
        _vm._v(" "),
        _c("ToggleWrapper", {
          attrs: {
            caption: "Card orientation",
            items: ["Horizontal", "Vertical"],
          },
          model: {
            value: _vm.Global.mockupConfig.verticalNav,
            callback: function ($$v) {
              _vm.$set(_vm.Global.mockupConfig, "verticalNav", $$v)
            },
            expression: "Global.mockupConfig.verticalNav",
          },
        }),
        _vm._v(" "),
        _c("SliderWrapper", {
          attrs: { caption: "Corner radius" },
          on: { updateSlider: _vm.updateBorderRadius },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nxt-out" },
          [
            _c("div", { staticClass: "bgout" }),
            _vm._v(" "),
            _c(
              "router-link",
              { staticClass: "btn bck", attrs: { tag: "div", to: "/model" } },
              [_c("span", { staticClass: "txt" }, [_vm._v("Back")])]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "btn main txt-blk",
                attrs: { tag: "div", to: "/services" },
              },
              [
                _c("span", { staticClass: "hvr" }),
                _vm._v(" "),
                _c("span", { staticClass: "txt" }, [_vm._v("Continue")]),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "intro-block" }, [
      _c("h5", { staticClass: "txt-grt" }, [_vm._v("Look & feel")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Customize your platform. Take inspiration in our presets or let your imagination roam free."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }